// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"c6f85f3d","137":"01bb5087","207":"f8521701","245":"a52308f8","309":"252b0321","332":"78e5bb2a","340":"6051a963","346":"5e493002","532":"248d5189","743":"b29c40c2","829":"338815bb","845":"34ba04d5"}[chunkId] + ".chunk.js";
};